import { render, staticRenderFns } from "./DishEditor.vue?vue&type=template&id=5789d9f6"
import script from "./DishEditor.vue?vue&type=script&lang=js"
export * from "./DishEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports